// ScheduleDateEventType values, hand-synched w/ PortCall.Models\Schedule\ScheduleDateEvent.cs
export enum ScheduleDateEventType {
    EstimatedDateEntered = 'EE',
    ActualDateEntered    = 'AE',
    EstimatedDateChanged = 'EC',
    ActualDateChanged    = 'AC',
}



// WEBPACK FOOTER //
// ./data/models/ScheduleDateEventType.ts